import { render } from "./GameScreen.vue?vue&type=template&id=0968c7d1"
import script from "./GameScreen.vue?vue&type=script&lang=js"
export * from "./GameScreen.vue?vue&type=script&lang=js"

import "./GameScreen.vue?vue&type=style&index=0&id=0968c7d1&lang=scss"

import exportComponent from "H:\\Website\\vglabgamejam2021\\arcanemachine\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__